const SingleLoanSkeleton = () => {
  return (
    <div className="w-full pr-[40px] pl-[10px] animate-pulse">
      {/* Header */}
      <div className="flex items-center h-[50px] mb-[10px] justify-between">
        <div className="flex items-center gap-[5px]">
          <div className="w-[17px] h-[17px] bg-gray-300 rounded" />
          <div className="w-[60px] h-[14px] bg-gray-300 rounded" />
          <div className="w-[17px] h-[17px] bg-gray-300 rounded" />
          <div className="w-[80px] h-[18px] bg-gray-300 rounded" />
        </div>
        <div className="flex items-center gap-[10px]">
          <div className="w-[16px] h-[16px] bg-gray-300 rounded-full" />
          <div className="w-[100px] h-[14px] bg-gray-300 rounded" />
          <div className="h-[40px] w-[100px] bg-gray-300 rounded-full" />
        </div>
      </div>

      {/* Balance Card */}
      <div className="h-[180px] w-full bg-gray-200 mb-[10px] p-[15px] rounded-[10px]">
        <div className="flex justify-between mb-3">
          <div className="w-[100px] h-[16px] bg-gray-300 rounded" />
          <div className="flex flex-col gap-2">
            <div className="w-[80px] h-[12px] bg-gray-300 rounded" />
            <div className="w-[120px] h-[14px] bg-gray-300 rounded" />
          </div>
        </div>
        <div className="w-[180px] h-[40px] bg-gray-300 rounded mb-3" />
        <div className="flex justify-between">
          <div className="w-[60%] flex flex-col gap-2">
            <div className="w-[200px] h-[16px] bg-gray-300 rounded" />
            <div className="w-[300px] h-[10px] bg-gray-300 rounded-full" />
          </div>
          <div className="flex flex-col gap-1">
            <div className="w-[80px] h-[12px] bg-gray-300 rounded" />
            <div className="w-[100px] h-[14px] bg-gray-300 rounded" />
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="h-[40px] flex justify-between w-full mb-[10px]">
        {["Repayment", "Borrower", "Guarantorship", "Action"].map(
          (tab, idx) => (
            <div key={idx} className="w-[90px] h-[30px] bg-gray-300 rounded" />
          )
        )}
      </div>

      {/* Controls */}
      <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px] mb-3">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="h-[40px] w-[120px] bg-gray-200 rounded" />
        ))}
        <div className="flex items-center px-3 h-[40px] w-[40%] bg-gray-200 rounded" />
      </div>

      {/* Table Headers */}
      <div className="h-[44px] px-[10px] w-full bg-gray-200 mb-[10px] flex items-center">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="w-[12%] h-[16px] bg-gray-300 rounded mr-[5px]"
          />
        ))}
      </div>

      {/* Table Rows */}
      {[...Array(5)].map((_, rowIdx) => (
        <div
          key={rowIdx}
          className="h-[40px] px-[10px] w-full bg-white mb-[7px] flex items-center"
        >
          {[...Array(8)].map((_, colIdx) => (
            <div
              key={colIdx}
              className="w-[12%] h-[14px] bg-gray-200 rounded mr-[5px]"
            />
          ))}
        </div>
      ))}

      {/* Pagination */}
      <div className="h-[50px] mb-[20px] flex items-center justify-between">
        <div className="flex items-center gap-[10px]">
          <div className="w-[100px] h-[14px] bg-gray-300 rounded" />
          <div className="w-[70px] h-[14px] bg-gray-300 rounded" />
          <div className="w-[50px] h-[14px] bg-gray-300 rounded" />
          <div className="w-[80px] h-[35px] bg-gray-200 rounded" />
        </div>
        <div className="w-[200px] h-[35px] bg-gray-300 rounded" />
      </div>
    </div>
  );
};

export default SingleLoanSkeleton;
